import React, {useContext, useEffect, useState, useRef} from 'react'
import Navbar from 'react-bootstrap/Navbar'
// import NavDropdown from 'react-bootstrap/NavDropdown'
// import Nav from 'react-bootstrap/Nav'
import UserContext from '../context/UserContext'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import './Topbar.css'
// import { useNavigate } from 'react-router-dom'
// import AutoLogout from './AutoLogout'
import Login from './Login'
import { appVersion } from '../config';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import {BsExclamationCircle} from 'react-icons/bs'
import ConfirmDialog from '../components/ConfirmDialog';
import useDeviceChanged from '../hooks/useDeviceChanged';



function Topbar(props) {
    // console.log("Topbar")
    const userCtx = useContext(UserContext)
    const baseURL = process.env.REACT_APP_MODE === "PROD" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST
    const [confirmDialogParams, setConfirmDialogParams] = useState({show:false})
    const isDeviceChanged = useDeviceChanged((state) => state.isChanged)

    const helpFiles = [
        {
        eventKey: "help-device-identifier",
        title: "Device Identifier Tip Sheet",
        file: "/assets/Check Your Device Identifier Tip Sheet PDI 2025 Final PDF 1.pdf",
        },
        {
            eventKey: "help-encryption",
            title:"Encryption Verification Tip Sheet",
            file: "/assets/MCL Encryption Instructions.pdf",
        }
    ]

    // const [disabledClasses, setDisabledClasses] = useState('')

    // maximum inactive period in seconds - if user is inactive for that time they will be auto-log out
    // const MAX_INACTIVITY_MILLISECONDS = (+process.env.REACT_APP_MAX_INACTIVE_MINUTES)*60*1000
    // const MAX_INACTIVITY_MILLISECONDS = (+(process.env.REACT_APP_MODE === "TEST" ? process.env.REACT_APP_MAX_INACTIVE_MINUTES_TEST : process.env.REACT_APP_MAX_INACTIVE_MINUTES_PROD))*60*1000
    // seconds before showing warning or renewing JWT
    // const SHOW_WARNING_BEFORE_LOGOUT_SECS = 120

    // let warningTimeout = MAX_INACTIVITY_MILLISECONDS - SHOW_WARNING_BEFORE_LOGOUT_SECS * 1000

    // timer to renew jwt
    // let jwtTimer
    // const jwtTimerRef = useRef()


    // const startJWTTimer = (timeout) => {
        

    //     if (userCtx.isLoggedIn) {
    //         // console.log('***** startJWTTimer ******',new Date(), "isLoggedIn", isLoggedIn)
    //         // console.log(`JwtTimer will start with timeout ${timeout/1000} seconds; will trigger at ${new Date(new Date().getTime() + timeout)}`)
    //         // const exp = jwtExpiiresMilliSecs(jwtToken())
    //         // console.log("Token will expire in: ", exp/1000, "seconds; at ", new Date(new Date().getTime() + exp ))

    //         jwtTimer = setTimeout(refreshJWT, timeout);
    //         jwtTimerRef.current = jwtTimer
    //     }
        
    // }



    // const stopJwtTimer = () => {
        
    //     if(jwtTimerRef.current !== undefined) {
    //         // console.log("**** Navbar stopJwtTimer: jwtTimer", jwtTimerRef.current)
    //         // console.log("**** Navbar clear jwtTimer")
    //         jwtTimerRef.current = clearTimeout(jwtTimerRef.current)
    //         // console.log("**** Navbar stopJwtTimer: Timer cleared: jwtTimer", jwtTimerRef.current)
    //     }
    // } 

    // const oktaLogout = async (url) => {
    //   await fetch(url, {
    //             method: 'GET',
    //             // headers: {
    //             //     Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
    //             //     'Content-Type': 'application/json'
    //             // },
    //             // body: JSON.stringify(body)
    //         })
    //         .then((response) => {
    //             console.log("okta logout response", response)
    //             if (response.ok) {
    //                 return response.json()
    //             } 
    //         })
    //         .then(data => {
    //             if (data !== null) {
    //                 console.log("Return from okta logout", data)
    //             }

    //         })
    //         .catch(e => {
    //             console.log("error in okta logout", e)
    //         })
    // }

    const closeConfirmDialog = (result) => {
        setConfirmDialogParams({show: false})
        if (result === 'confirm') {
            userCtx.Logout();
            props.onLogout();
        }
    }

    const onLogout = () => {
      // console.log("edit mode", props.editMode)
      // console.log("isDeviceChanged", isDeviceChanged)
      if (props.editMode && isDeviceChanged) {
          setConfirmDialogParams({
              show: true,
              text: ['Displayed device record may have changed.', 'If you log out now, all unsaved changes will be lost. If you want to save changes click No, then click Save Changes button before logging out.', ' ', 'Are you sure you want to log out?'],
              textClass: 'confirmation-text',
              // prompt_class: styles['alert-prompt-black'],
              cancel_button_text: 'No',
              confirm_button_text: 'Yes, log out',
              confirm_button_variant: 'primary',
              onClose: (result) => closeConfirmDialog(result),
              title: 'Attention',
              title_class: 'alert-title',
              icon: <BsExclamationCircle />,
              confirm_only: false,
          })
      } else {
          userCtx.Logout();
          props.onLogout();
      }
        
    }
    


    const onHelpSelect = (eventKey, event) => {
        console.log("Item selected", eventKey, event)

        const fileInfo = helpFiles.filter(fileInfo => fileInfo.eventKey === eventKey)
        if (fileInfo.length > 0) {
            window.open(fileInfo[0].file, fileInfo[0].title);
        }


    }

    // const logout = () => {
    //     setUser('')
    //     setIsLoggedIn(false)
    //     setSelectedYear(-1)
    // }

    
    
    // useEffect(() => {
    //     if (userCtx.isLoggedIn && !!userCtx.jwt) {
    //         setDisabledClasses('')

    //         // console.log("Token expires in: ", jwtExpiiresMilliSecs()/1000, "seconds" )
    //         // const token = userCtx.jwtToken()
    //         const token = userCtx.jwt
    //         // console.log("TOKEN", token)
    //         warningTimeout = userCtx.jwtExpiiresMilliSecs(token) - SHOW_WARNING_BEFORE_LOGOUT_SECS * 1000
    //         // console.log("Token timeout", warningTimeout/1000/60, "minutes")
    //         startJWTTimer(warningTimeout)
    //     } else {
    //         setDisabledClasses('disabled')

    //         stopJwtTimer()
    //     }
    // },[userCtx.isLoggedIn])


    // const refreshJWT = async (extendSeconds) => {
    //     // console.log("refreshJWT - isLoggedIn", userCtx.isLoggedIn)
    //     if (!userCtx.isLoggedIn) {
            
    //         return
    //     }
    //     // sometimes request fails with 401 code (unauthorized). Catch it and repeat 3 attempts
    //     let error = ""
    //     for(let refreshAttempts = 0; refreshAttempts < 3; refreshAttempts++) {
    //         error = ""


    //         const now = new Date()
    //         // console.log(`*** Refresh JWT: now=${now} extend for ${MAX_INACTIVITY_MILLISECONDS/1000} seconds => ${new Date(now.getTime() + MAX_INACTIVITY_MILLISECONDS)}`)
    //         // const params = {
    //         //     extendSeconds: MAX_INACTIVITY_MILLISECONDS/1000,
    //         // }

    //         // const apiUrl = (process.env.REACT_APP_MODE === "TEST" ? process.env.REACT_APP_API_URL_TEST : process.env.REACT_APP_API_URL_PROD)

    //         const apiUrl = (process.env.REACT_APP_MODE === "TEST" ? process.env.REACT_APP_AUTH_API_URL_TEST : process.env.REACT_APP_AUTH_API_URL_PROD)


    //         console.log("Running in mode", process.env.REACT_APP_MODE)
    //         console.log("AUTH_API URL", apiUrl)
            
    //         const params = {
    //             user_id: userCtx.user,
    //             app_name: process.env.REACT_APP_KID,
    //             extendSeconds: MAX_INACTIVITY_MILLISECONDS/1000,
    //         }
            
    //         // console.log("**** refreshJWT *****", new Date(), "Params:", params, "json", JSON.stringify(params))
    //         // console.log(`Header: Authorization: Bearer ${encodeURIComponent((jwtToken()))}`)
    //         // const response = await fetch(`${process.env.REACT_APP_API_URL}/jwt/refresh`, {
    //         const response = await fetch(`${apiUrl}/api/jwt/refresh`, {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     // 'Authorization': `Bearer ${encodeURIComponent(userCtx.jwtToken())}`
    //                     'Authorization': `Bearer ${encodeURIComponent(userCtx.jwt)}`
    //                 },
    //                 method: 'POST',
    //                 body: JSON.stringify(params)
    //             })
    //             .catch((error) => {
    //                 console.log("Error:", error)
    //                 // setErrorMessage({
    //                 //     isError: true,
    //                 //     headerText: 'Error while trying to refresh token',
    //                 //     errorText: `${error.message}. If the error persists please contact the Support Center`,
    //                 // })
    //                 // console.log(typeof error, error.name, error.message)
    //                 error = "error"
    //             })

    //         if (error === "") {
    //             const data = await response.json()

    //             // console.log(`${new Date()} - New Token received ${data}`)
    //             const jwt = data.JWT
    //             // console.log("new jwt: ", jwt)
    //             if (jwt !== undefined && jwt !== null ) {
    //                 // console.log(`new expiration date ${new Date(1000*(+(parseJwt(jwt).exp)))}`)
    //                 // update token
    //                 userCtx.setJwtToken(data.JWT)
                    
    //                 // console.log("LIST DATA", data)
    //                 // console.log(`${new Date()} - start new timeout to ${new Date(new Date().getTime() + warningTimeout)}`)
    //                 warningTimeout = userCtx.jwtExpiiresMilliSecs(jwt) - SHOW_WARNING_BEFORE_LOGOUT_SECS * 1000
    //                 startJWTTimer(warningTimeout)
    //                 break
    //             } else {
    //                 error = "error"
    //             }
                
    //         }
    //     }

    //     if (error !== "") {
    //         console.log("*** 3 attempts to refresh JWT failed! Giving up... *** ")

    //     }
    // }

    // useEffect(() => {
    //     setUserName(userCtx.user_name || userCtx.user )
    // }, [userCtx.user])

    return (
        <>
            <Navbar expand={true} className="bg-secondary-subtle py-0 my-0" >
                <Container fluid>
                    <Navbar.Brand >McLean Inventory Portal (v.{appVersion})</Navbar.Brand>
                        <Navbar.Collapse className="justify-content-end">  
                            <Navbar.Text>
                                {userCtx.isLoggedIn &&  
                                    <>
                                    Welcome <span className='topbar-username'>{userCtx.full_name}</span> 
                                    </>
                                }
                            </Navbar.Text>

                            {userCtx.isLoggedIn &&
                                <Row>
                                    <Col xs="auto" className='ms-3 pe-1'>
                                        <DropdownButton 
                                            title="Help" 
                                            variant="outline-secondary" 
                                            size="sm" 
                                            onSelect={onHelpSelect} 
                                            // className="dropdown-start"
                                            align="end"
                                            drop="down"
                                            data-bs-offset="10,20" >
                                            {helpFiles.map(fileInfo => <Dropdown.Item key={fileInfo.eventKey} eventKey={fileInfo.eventKey}>{fileInfo.title}</Dropdown.Item>)}
                                        </DropdownButton>
                                    </Col>

                                    <Col xs="auto" className='ms-1 me-3 ps-1'>
                                        <Button  variant="outline-secondary" size="sm" onClick={onLogout}>Logout</Button>
                                    </Col>
                                </Row>
                            }


                    </Navbar.Collapse>
                
                </Container>
            </Navbar>
            {/* <AutoLogout onLogout={onLogout} /> */}
            <Login />

            {confirmDialogParams.show &&
                <ConfirmDialog 
                    show={confirmDialogParams.show}
                    iconColor='red'
                    iconSize='2rem'
                    icon={confirmDialogParams.icon}
                    title={confirmDialogParams.title}
                    title_class={confirmDialogParams.title_class}
                    text={confirmDialogParams.text}
                    textClass={confirmDialogParams.textClass}
                    prompt_class={confirmDialogParams?.prompt_class}
                    prompt={confirmDialogParams?.prompt}
                    cancel_button_text={confirmDialogParams.cancel_button_text}
                    confirm_button_text={confirmDialogParams.confirm_button_text}
                    confirm_button_variant={confirmDialogParams.confirm_button_variant}
                    onClose={confirmDialogParams.onClose}
                    confirm_only={confirmDialogParams.confirm_only}
                />
            }
        </>
  )
}

export default Topbar
